import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TableGenericViewControllerDelegate, TableGenericViewController, NavOptions } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { TableGenericFilter } from '../TableGeneric/TableGenericInteractor';
import { PropertyBuildingViewModel } from '../../Screen/PropertyBuilding/PropertyBuildingViewModel';
import { PropertyBuildingViewController, PropertyBuildingViewControllerDelegate } from '../../Screen/PropertyBuilding/PropertyBuildingViewController';
import { RealEstateRegistrationViewModel } from '../../Screen/RealEstateRegistration/RealEstateRegistrationViewModel';
import { RealEstateRegistrationViewController } from '../../Screen/RealEstateRegistration/RealEstateRegistrationViewController';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { PermissionWrapper } from '../../Funcoes/PermissionWrapper';

export class PropertyBuildingCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, PropertyBuildingViewControllerDelegate {

    private pointType: string
    constructor() {
        this.pointType = ""
    }

    getRoute(): JSX.Element[] {
        return [
            this.routeTableBuilding(),
            this.routeFormBuilding(),
            this.routeTableRealEstate(),
            this.routeFormRealEstate()
        ]
    }

    private routeTableBuilding(): JSX.Element {

        var viewModel = new TableGenericViewModel("geppropedificacoes")
        return (<ProtectedRoute path="/:base/propriedade/tipo/:type/:idPropriedade/edificacoes" exact={true} component={(props: any) => {
            var idFk = props.match.params.idPropriedade
            var filter = new TableGenericFilter('Propriedade', idFk)
            var pointType = props.match.params.type
            this.pointType = pointType
            const requiredPermissions = [
                "acao.edif.urbano.visita.ver",
                "acao.edif.rural.visita.ver",
                "acao.edif.cemiterio.visita.ver",
                "acao.edif.urbano.proc_adm.ver",
                "acao.edif.rural.proc_adm.ver",
                "acao.edif.cemiterio.proc_adm.ver",

                'acao.edif.urbano.proc_adm.adicionar',
                'acao.edif.urbano.proc_adm.editar',
                'acao.edif.urbano.proc_adm.excluir',

                'acao.edif.rural.proc_adm.adicionar',
                'acao.edif.rural.proc_adm.editar',
                'acao.edif.rural.proc_adm.excluir',

                'acao.edif.cemiterio.proc_adm.adicionar',
                'acao.edif.cemiterio.proc_adm.editar',
                'acao.edif.cemiterio.proc_adm.excluir',
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPermissions} delegate={this}>{(permissions, delegate) => {

                    var arrayOptions = new Array<NavOptions>()
                    let propertyEdificationPerm = false


                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }
                    if (permissions["acao.edif.urbano.proc_adm.adicionar"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.adicionar"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.adicionar"] == false && pointType === 'C') {
                        actionPerms.add = false
                    }
                    if (permissions["acao.edif.urbano.proc_adm.editar"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.editar"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.editar"] == false && pointType === 'C') {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.edif.urbano.proc_adm.excluir"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.excluir"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.excluir"] == false && pointType === 'C') {
                        actionPerms.del = false
                    }

                    //exibir opção de Visita
                    let visitEdificationPerm = false
                    if (permissions["acao.edif.urbano.visita.ver"] == true && pointType === 'U' ||
                        permissions["acao.edif.rural.visita.ver"] == true && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.visita.ver"] == true && pointType === 'C') {
                        visitEdificationPerm = true
                    }
                    //exibir opção de Edificação
                    if (permissions["acao.edif.urbano.proc_adm.ver"] == true && pointType === 'U' ||
                        permissions["acao.edif.rural.proc_adm.ver"] == true && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.proc_adm.ver"] == true && pointType === 'C') {
                        propertyEdificationPerm = true
                    }

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocumentsBuilding(navigation, item),
                        isSelection: true
                    })
                    arrayOptions.push({
                        title: "Cadastro Técnico",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerRealEstateRegistration(navigation, item),
                        isSelection: true
                    })
                    if (propertyEdificationPerm) {
                        arrayOptions.push({
                            title: "Processo Administrativo",
                            action: (navigation: any, item: any, component: React.Component) => delegate.routerAdminProcess(navigation, item),
                            isSelection: true
                        })
                    }
                    if (visitEdificationPerm) {
                        arrayOptions.push({
                            title: "Visitas",
                            action: (navigation: any, item: any, component: React.Component) => delegate.routerVisit(navigation, item),
                            isSelection: true
                        })
                    }
                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Edificações"}
                        filter={[filter]}
                        options={arrayOptions}
                        actionPerms={actionPerms}
                    />)

                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormBuilding(): JSX.Element {
        var viewModel = new PropertyBuildingViewModel()
        return (<ProtectedRoute path="/:base/propriedade/tipo/:type/:idPropriedade/edificacoes/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idFk = props.match.params.idPropriedade
            var pointType = props.match.params.type
            this.pointType = pointType
            return (
                <PropertyBuildingViewController
                    navigation={props}
                    viewModel={viewModel}
                    delegate={this}
                    idPrimary={idPk}
                    idProperty={idFk}
                    pointType={pointType}
                />)
        }} />)
    }
    //cad tecnico
    private routeTableRealEstate(): JSX.Element {
        var arrayOptions = new Array<NavOptions>()
        arrayOptions.push({
            title: "Arquivos Digitais (Documentos)",
            action: (navigation: any, item: any, component: React.Component) => this.routerDocumentsRealEstateRegistration(navigation, item),
            isSelection: true
        })

        var viewModel = new TableGenericViewModel("gepcadastroimobiliario")
        return (<ProtectedRoute path="/:base/edificacao/tipo/:type/:idEdificacao/cadastro-imobiliario" exact={true} component={(props: any) => {
            var idFk = props.match.params.idEdificacao
            var filter = new TableGenericFilter('Edificação', idFk)
            var pointType = props.match.params.type
            this.pointType = pointType

            return (<TableGenericViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Cadastro Técnico"}
                filter={[filter]}
                options={arrayOptions}
            />)
        }} />)
    }
    // cad tec
    private routeFormRealEstate(): JSX.Element {
        var viewModel = new RealEstateRegistrationViewModel()
        return (<ProtectedRoute path="/:base/edificacao/tipo/:type/:idEdificacao/cadastro-imobiliario/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idFk = props.match.params.idEdificacao
            var pointType = props.match.params.type
            this.pointType = pointType
            return (<RealEstateRegistrationViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idRealEstate={idFk}
                pointType={pointType}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        if (viewModel.getTable() == "geppropedificacoes" && filter) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/propriedade/tipo/${this.pointType}/${filter[0].getValue()}/edificacoes/cad/0`);
            return;
        } else if (viewModel.getTable() == "gepcadastroimobiliario" && filter) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/edificacao/tipo/${this.pointType}/${filter[0].getValue()}/cadastro-imobiliario/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        if (viewModel.getTable() == "geppropedificacoes" && filter) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/propriedade/tipo/${this.pointType}/${filter[0].getValue()}/edificacoes/cad/${idSelection}`);
            return;
        } else if (viewModel.getTable() == "gepcadastroimobiliario" && filter) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/edificacao/tipo/${this.pointType}/${filter[0].getValue()}/cadastro-imobiliario/cad/${idSelection}`);
            return;
        }
    }

    private routerDocumentsBuilding(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/edificacao/${item}/arquivos`);
    }

    private routerRealEstateRegistration(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/edificacao/tipo/${this.pointType}/${item}/cadastro-imobiliario`);
    }

    private routerDocumentsRealEstateRegistration(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/cadastro-imobiliario/${item}/arquivos`);
    }

    private routerAdminProcess(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/edificacao/tipo/${this.pointType}/${item}/processo-administrativo`);
    }

    private routerVisit(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/edificacao/tipo/${this.pointType}/${item}/visita`);
    }
}